// import { resetPassword } from "@services/user.service";

const API_URL = {
  AUTH: {
    INVITATION_PROFILE: "/invitation/profile",
    INVITATION_VALID: "/invitation/verify",
    LOGIN: "/login",
    LOGIN_ACCESS: "/login/accesstoken",
    LOGIN_USER: "/login",
    MAIL_VERIFICATION: "/register/verify-email/",
    REFRESH: "/login/refresh",
    RESEND_MAIL_VERIFICATION: "/register/resend-mail-verification/",
  },
  BOOKING: {
    ADD_EXTERNAL_GUEST: "/add-external-participant",
    ADD_GUEST: "/add-participant",
    BOOKING_CALENDAR: "/calendar/",
    BOOKING_SAVE: "/booking/save",
    BOOKING_SLOT: "/resources/",
    CALCULATE_PRICE: "/calculate-price",
    CALENDAR_PARTICIPANT: "/booking/",
    CANCEL: "/booking/cancelBooking/",
    CHECK_CANCEL_FEASIBILITY: "/booking/checkBookingCancellable/",
    CHECK_GUEST_LIST: "/check-participants",
    GET_GUEST_LIST: "/users/",
    GET_QUOTE_INFO: "/resources/quota/",
    PAYMENT_STATUS: "/booking/paymentStatus/",
  },
  CONTACT_PERSON: {
    GET_CONTACT_PERSON: "/contact-info/",
  },
  DASHBOARD: {
    ORGANIZATION_FINDER: "/organization",
  },
  DELETEACCOUNT: {
    ACCOUNT_DELETE: "/user/deleteAccount",
    CHECK_ACCOUNT_DELETE: "/user/checkAccountDeletion",
    CHECKPASSORD_ON_ACCOUNT_DELETE: "/user/checkPasswordOnAccountDeletion",
  },
  NOTIFICATION: {
    DISABLE: "/notification/subscription/disable",
    ENABLE: "/notification/subscription/enable",
    SUBSCRIBE: "/notification/subscribe",
    UNSUBSCRIBE: "/notification/unsubscribe",
  },
  ORGANISATION: {
    GET_LOCATION: "/organization/",
  },
  PASSWORD: {
    INVITED_SET_PASSWORD: "/invitation/reset",
    RESET_PASSWORD: "/resetpassword",
    RESET_PASSWORD_TOKEN: "/reset/verify",
    SET_PASSWORD: "/reset",
  },
  UNIT: {
    DETAILS: "/location/",
  },
  USER: {
    DELETE_MEMBER_INFO: "/user/memberinfo",
    GET_SELECTED_LANGUAGE: "/language",
    MEMBER_INFO: "/user/memberinfo",
    REGISTER: "/register",
    REGISTER_OPTIONS: "/register-options",
    REGISTER_VALIDATE: "/register-validate",
    UPDATE_USER_LANGUAGE: "/language",
    USER_BOOKING_DETAILS: "/booking/listing/",
    USER_BOOKINGS: "/booking/listing",
    USER_PROFILE: "/user/profile",
  },
};

export default API_URL;
